import { render, staticRenderFns } from "./IntroSection.vue?vue&type=template&id=e877b204&scoped=true&"
import script from "./IntroSection.vue?vue&type=script&lang=js&"
export * from "./IntroSection.vue?vue&type=script&lang=js&"
import style0 from "./IntroSection.vue?vue&type=style&index=0&id=e877b204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e877b204",
  null
  
)

export default component.exports